module.exports = __webpack_public_path__ + "static/0031-89b9ed34f517dc7446b1c422a2fbb4b8.png";